import React from "react";
import { VLYT } from "@/constants/testIds/vlyt";
import useReveal from "@/hooks/useReveal";

const STATS = [
  { k: "< 4 min", v: "Royal match time" },
  { k: "4.7 / 5", v: "avg. driver rating" },
  { k: "0%", v: "fee leakage" },
  { k: "24 / 7", v: "on-campus support" },
];

export default function StatsStrip() {
  const { ref, inView } = useReveal({ threshold: 0.2 });
  return (
    <section
      ref={ref}
      data-testid={VLYT.stats.section}
      className="relative py-16 md:py-20 border-b border-[color:var(--vlyt-border)] bg-[color:var(--vlyt-surface-2)]"
    >
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
        {STATS.map((s, i) => (
          <div
            key={s.k}
            className={`reveal ${inView ? "in" : ""} border-l-2 border-[color:var(--vlyt-lime)] pl-5`}
            style={{ transitionDelay: `${i * 60}ms` }}
          >
            <div className="text-h2 font-display text-[color:var(--vlyt-text)]">{s.k}</div>
            <div className="mt-1 font-mono text-[12px] uppercase tracking-[0.28em] text-[color:var(--vlyt-muted)]">
              {s.v}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
